<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "NoAuthLayout",
  computed: {
    coupon() {
      return this.$cookies.get("coupon");
    },
    couponMonths() {
      return this.$cookies.get("coupon_months");
    },
    couponPrepend() {
      let coupon_prepend = this.$cookies.get("coupon_prepend");
      return coupon_prepend ? coupon_prepend : "";
    },
    couponMessage() {
      if (!this.coupon) return null;
      let trialLength =
        this.couponMonths == 1
          ? `free month`
          : `${this.couponMonths} free months`;
      return `🎁 ${this.couponPrepend} You clicked a VIP link! Enjoy an extra ${trialLength} when you sign up now!`;
    },
  },
};
</script>

<style lang="scss" scoped>
.coupon-applied {
  padding-top: 60px;
}
</style>
